<template>
    <div class="license-key-template">
        <p class="mt-1 has-text-weight-medium">{{ infoBlockHeader }}</p>
        <ul class="license-key-prop-list">
            <li v-for="(label, parameterId) in licKeyTexts" :key="parameterId" v-if="label && licKey[parameterId]">
                <b>{{ label }}:</b> {{ licKey[parameterId] }}
            </li>
        </ul>
        <p
            :class="base.licensing_info.verificationResult.commerceLicenseMessage.type"
            class="mt-0 mb-1"
            v-html="base.licensing_info.verificationResult.commerceLicenseMessage.message"
        ></p>
        <p
            :class="base.licensing_info.verificationResult.freeUsingMessage.type"
            v-show="!base.licensing_info.license.isActivatingLicesence"
            class="mb-0"
            v-html="base.licensing_info.verificationResult.freeUsingMessage.message"
        ></p>
    </div>
</template>

<script>
    export default {
        props: {
            base: Object,
        },
        data() {
            return {
                locElements: licenseLocalization.locElements,
                licKeyTexts: licenseLocalization.licKeyTexts,
            }
        },
        computed: {
            licKey() {
                return this.base.licensing_info.license;
            },
            infoBlockHeader() {
                if (this.base.licensing_info.license.isActivatingLicesence) {
                    return this.locElements.new_key_info_block_header;
                }

                return this.locElements.license_info_block_header;
            },
        },
    }
</script>
